import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import KineticLines from "@/components/KineticLines";
import { Crosshair, TechLabel } from "@/components/Bits";
import Reveal from "@/components/Reveal";

export default function PageHeader({ index, eyebrow, title, sub }) {
  return (
    <header className="relative border-b border-white/10 px-5 pb-16 pt-32 md:px-10 md:pb-24 md:pt-40 lg:px-16">
      <Crosshair className="right-6 top-28 hidden text-xl md:block" />
      <Crosshair className="right-6 bottom-6 hidden text-xl md:block" />
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Link
            to="/"
            data-testid="pageheader-home-link"
            className="inline-flex items-center gap-2 font-tech text-[10px] uppercase tracking-[0.3em] text-white/40 transition-colors duration-300 hover:text-molten"
          >
            <ArrowLeft className="size-3.5" /> MMC S.r.l.
          </Link>
          <TechLabel className="mt-8 block text-molten">
            {index} / {eyebrow}
          </TechLabel>
        </Reveal>
        <KineticLines
          lines={[title]}
          className="mt-5 font-display text-5xl font-semibold uppercase leading-[0.98] tracking-tight sm:text-6xl lg:text-8xl"
        />
        {sub && (
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-fog md:text-lg">{sub}</p>
          </Reveal>
        )}
      </div>
    </header>
  );
}
